import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { SharedUiUniversalSearchFormWrapper } from '../../common/universal-search-form/universal-search-form-wrapper';
import { UniversalSearchFormExperiment } from './universal-search-form-experiment';

export const Playback: React.FunctionComponent = () => (
  <Experiment name="Vrbex_generic">
    <ExperimentControl>
      <UniversalSearchFormExperiment />
    </ExperimentControl>
    <ExperimentVariant bucket={1}>
      <SharedUiUniversalSearchFormWrapper />
    </ExperimentVariant>
  </Experiment>
);
